module.exports = __webpack_public_path__ + "img/champagne-glasses.1e0aa60a.svg";